import { ListBranchModel } from "app/area/subscriber-groups/user-members/types-store";

export const searchFilterChanged = (requestedModel: ListBranchModel): boolean => {
  const { name, email, hideDisabledUsers } = requestedModel ?? {};
  return !!name || !!email || hideDisabledUsers !== undefined;
};
